import { render, staticRenderFns } from "./RoleDrawerSettingsTab.vue?vue&type=template&id=a7afc450&scoped=true&"
import script from "./RoleDrawerSettingsTab.vue?vue&type=script&lang=js&"
export * from "./RoleDrawerSettingsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7afc450",
  null
  
)

export default component.exports